import { EVENTS } from '@archetype-themes/utils/events'

/*============================================================================
  Promo regalo de Mánamu
  - Si el carrito (sin contar el regalo) llega al mínimo, agrega 1 unidad del
    producto de regalo con la propiedad oculta _regalo.
  - Si baja del mínimo o la promo se apaga, quita la línea de regalo.
  - El $0 lo pone el descuento automático de Shopify. Si después de agregar el
    regalo el descuento no se aplicó (descuento pausado, vencido o con otra
    condición), se quita para no cobrarlo, y no se reintenta con ese mismo carrito.
  Config: snippets/manamu-regalo.liquid
==============================================================================*/

const config = JSON.parse(document.getElementById('manamu-regalo-config')?.textContent || 'null')
const root = window.Shopify?.routes?.root || '/'
const PROPIEDAD = '_regalo'
const CLAVE_FALLO = 'manamu-regalo-fallo'

let corriendo = false
let pendiente = false

const esRegalo = (item) => Boolean(item.properties && item.properties[PROPIEDAD])
const base = (cart) => cart.items.filter((item) => !esRegalo(item)).reduce((suma, item) => suma + item.original_line_price, 0)

function leerFallo() {
  try {
    return sessionStorage.getItem(CLAVE_FALLO)
  } catch (e) {
    return null
  }
}

function guardarFallo(valor) {
  try {
    sessionStorage.setItem(CLAVE_FALLO, String(valor))
  } catch (e) {}
}

async function getCart() {
  const response = await fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' })
  return response.json()
}

async function post(ruta, body) {
  const response = await fetch(`${root}${ruta}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...body, sections: 'cart-ajax' })
  })
  if (!response.ok) throw response
  return response.json()
}

function quitarRegalos(cart) {
  const updates = {}
  cart.items.filter(esRegalo).forEach((item) => (updates[item.key] = 0))
  return post('cart/update.js', { updates })
}

// Vuelve a pintar el carrito (dropdown y página) y la burbuja del header.
function refrescar(state) {
  document.dispatchEvent(new CustomEvent('cart:build'))

  const html = state?.sections?.['cart-ajax']
  if (!html) return
  const nueva = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-link__bubble')
  if (!nueva) return
  document.querySelectorAll('toggle-cart .cart-link__bubble').forEach((burbuja) => {
    burbuja.outerHTML = nueva.outerHTML
  })
}

async function sincronizar() {
  if (!config) return
  if (corriendo) {
    pendiente = true
    return
  }
  corriendo = true

  try {
    const cart = await getCart()
    const regalos = cart.items.filter(esRegalo)
    const totalBase = base(cart)
    const califica = config.activo && config.variante && totalBase > 0 && totalBase >= config.minimo
    let state = null

    if (!califica && regalos.length) {
      state = await quitarRegalos(cart)
    } else if (califica && !regalos.length && leerFallo() !== String(totalBase)) {
      try {
        state = await post('cart/add.js', {
          items: [{ id: config.variante, quantity: 1, properties: { [PROPIEDAD]: 'Regalo por compra mínima' } }]
        })
      } catch (e) {
        // Sin inventario u otro rechazo de Shopify: no insistir con este carrito.
        guardarFallo(totalBase)
      }

      if (state) {
        const despues = await getCart()
        const descontado = despues.items
          .filter((item) => item.variant_id === config.variante)
          .some((item) => item.final_line_price < item.original_line_price)

        if (!descontado) {
          guardarFallo(totalBase)
          state = await quitarRegalos(despues)
        }
      }
    } else if (califica && (regalos.length > 1 || regalos[0]?.quantity > 1)) {
      // Siempre una sola unidad de regalo.
      const updates = {}
      regalos.forEach((item, i) => (updates[item.key] = i === 0 ? 1 : 0))
      state = await post('cart/update.js', { updates })
    }

    if (state) refrescar(state)
  } catch (e) {
    console.warn('[manamu-regalo]', e)
  } finally {
    corriendo = false
    if (pendiente) {
      pendiente = false
      sincronizar()
    }
  }
}

document.addEventListener(EVENTS.ajaxProductAdded, sincronizar)
document.addEventListener(EVENTS.cartUpdated, sincronizar)

if (config?.articulos > 0) sincronizar()
